import routes from "@/constants/routes";

const MidCta = () => (
  <div className="px-5 lg:px-20 mx-auto max-w-7xl">
    <div className="bg-landing-blue rounded-[20px] px-8 py-11 md:py-14 flex flex-col items-center gap-6 text-center">
      <h2 className="text-2xl md:text-4xl font-bold text-white max-w-[22ch]">
        Like what you see? Get started with Keyzy.
      </h2>
      <a
        href={routes.searchHomes}
        className="inline-block px-8 py-3 text-base font-bold text-white rounded-md bg-landing-cherry hover:scale-105 transition duration-300 ease-in-out transform"
      >
        Browese homes
      </a>
    </div>
  </div>
);

export default MidCta;
